export class AsyncBuffer {
  constructor() {
    this.locked = false;
    this.pendingPromises = [];
  }

  isLocked() {
    return this.locked;
  }

  lock() {
    this.locked = true;
  }

  wait() {
    return new Promise((resolve, reject) => {
      this.pendingPromises.push({
        resolve,
        reject
      })
    });
  }

  resolve(value) {
    this.pendingPromises.forEach(({ resolve, reject }) => {
      resolve(value);
    });
  }
  
  reject(error) {
    this.pendingPromises.forEach(({ resolve, reject }) => {
      reject(error);
    });
  }

  reset() {
    this.locked = false;
    this.pendingPromises = [];
  }
}
